export default {
  headerTasks: 'Úlohy údržby',
  headerAttachments: 'Prílohy',
  noAssetBlobs: 'Zariadenie {asset} nemá žiadnu dokumentáciu.',
};
